import React, { useRef } from 'react';
import { createPortal } from 'react-dom';
export const renderToolbarInPortal = (Component, baseElementId) => ({ ...props }) => {
    const elementId = props.id ? `${baseElementId}-${props.id}` : baseElementId;
    const portalElement = useRef(null);
    if (portalElement.current === null && typeof document !== 'undefined') {
        portalElement.current = document.getElementById(elementId);
    }
    return portalElement.current
        ? createPortal(React.createElement(Component, { ...props, containerRef: portalElement.current }), portalElement.current)
        : null;
};
export const RicosButton = ({ onClick, getIcon, className, iconClass, iconStyle, showLabel, getLabel, tooltip, }) => {
    const Icon = getIcon && getIcon();
    return (React.createElement("button", { "aria-label": tooltip, className: className, onClick: onClick, onMouseDown: (e) => e.preventDefault() },
        Icon && (React.createElement("div", { className: iconClass, style: iconStyle },
            React.createElement(Icon, null))),
        showLabel && React.createElement("div", { style: { paddingTop: '8px', color: 'currentColor' } }, getLabel?.())));
};
//# sourceMappingURL=external-toolbar-utils.js.map